import React, { useState } from 'react';
import { motion } from "framer-motion";
import { useHistory, useParams, Link } from "react-router-dom";
import { onDragEnd } from "../resources/utils";

import styles from './Reward.module.scss';

import ProductBannerCard from "../components/ProductBannerCard";
import ProductCard from "../components/ProductCard";
import Media from "../components/Media";
import Welcomer from "../components/Welcomer";

const variants = {
  enter: {
    x: -1000,
    opacity: 0
  },
  center: {
    zIndex: 1,
    x: 0,
    opacity: 1
  },
  exit: {
    zIndex: 0,
    x: 1000,
    opacity: 0
  }
};

const Reward = ({ config, rewards, customer }) => {
  const [showDetails, toggleDetails] = useState(true);
  let history = useHistory();
  let { rewardID } = useParams();

  let rewardData = rewards.find(x => x.id === rewardID);
  let rewardCard = config.rewards.find(x => x.id === rewardID);
  // console.log(rewardData, rewardCard);

  if(!rewardData || !rewardCard) {
    return (
      <motion.div
      className={styles.reward}
      data-has-footer={customer && customer.accountEnabled}
      variants={variants}
      initial="enter"
      animate="center"
      exit="exit"
      transition={{
        x: { type: "spring", stiffness: 300, damping: 30 },
        opacity: { duration: 0.2 }
      }}
      drag="x"
      dragConstraints={{ left: 0, right: 0 }}
      dragElastic={0.5}
      onDragEnd={(e, { offset, velocity }) => {
        onDragEnd(
          offset,
          velocity,
          () => {
            history.goBack();
          },
          () => {
            // do nothing
          },
        )
      }}
      >
        {
          customer && customer.accountEnabled &&
          <Welcomer logo={config.logo} customer={customer} />
        }
        <div onClick={() => { history.goBack(); }} className={styles.breadcrumb}>
          <svg width="17" height="9" viewBox="0 0 17 9" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M5.19752 0.123583L5.46584 0.372138C5.64366 0.53688 5.64366 0.803996 5.46584 0.968773L2.28107 3.90235H16.5446C16.7961 3.90235 17 4.09124 17 4.32422V4.67579C17 4.90877 16.7961 5.09766 16.5446 5.09766H2.28107L5.46584 8.03124C5.64366 8.19598 5.64366 8.46309 5.46584 8.62787L5.19752 8.87643C5.0197 9.04117 4.73139 9.04117 4.55357 8.87643L0.133383 4.7983C-0.0444355 4.63356 -0.0444355 4.36645 0.133383 4.20167L4.55357 0.123583C4.73139 -0.0411943 5.0197 -0.0411943 5.19752 0.123583Z" fill="#1D1D1E"/>
          </svg>
          <span>{ rewardCard && rewardCard.title ? rewardCard.title : 'Reward'}</span>
        </div>
        <strong>Something went wrong when opening this reward, please try reloading the page.</strong>
      </motion.div>
    )
  }

  return (
    <motion.div
    className={styles.reward}
    data-has-footer={customer && customer.accountEnabled}
    variants={variants}
    initial="enter"
    animate="center"
    exit="exit"
    transition={{
      x: { type: "spring", stiffness: 300, damping: 30 },
      opacity: { duration: 0.2 }
    }}
    drag="x"
    dragConstraints={{ left: 0, right: 0 }}
    dragElastic={0.5}
    onDragEnd={(e, { offset, velocity }) => {
      onDragEnd(
        offset,
        velocity,
        () => {
          history.goBack();
        },
        () => {
          // do nothing
        },
      )
    }}
    >
      {
        customer && customer.accountEnabled &&
        <div className={styles.top}>
          <Media image={config.logo} />
          <span>You have <strong>{ customer.points.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") }</strong> points.</span>
        </div>
      }
      <div onClick={() => { history.goBack(); }} className={styles.breadcrumb}>
        <svg width="17" height="9" viewBox="0 0 17 9" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M5.19752 0.123583L5.46584 0.372138C5.64366 0.53688 5.64366 0.803996 5.46584 0.968773L2.28107 3.90235H16.5446C16.7961 3.90235 17 4.09124 17 4.32422V4.67579C17 4.90877 16.7961 5.09766 16.5446 5.09766H2.28107L5.46584 8.03124C5.64366 8.19598 5.64366 8.46309 5.46584 8.62787L5.19752 8.87643C5.0197 9.04117 4.73139 9.04117 4.55357 8.87643L0.133383 4.7983C-0.0444355 4.63356 -0.0444355 4.36645 0.133383 4.20167L4.55357 0.123583C4.73139 -0.0411943 5.0197 -0.0411943 5.19752 0.123583Z" fill="#1D1D1E"/>
        </svg>
        <span>{ rewardCard.title }</span>
      </div>

      <div className={styles.rewardMain}>
        <Media image={rewardCard.image} />
        <div>
          { rewardData.points === 0 ? <strong>FREE</strong> : <strong>{ rewardData.points } points</strong> }
          <p>{ decodeURIComponent(rewardCard.description) }</p>
        </div>
      </div>

      {
        (customer && customer.accountEnabled) &&
        <Link to={`/rewards/confirm/${rewardID}`} className={styles.button}>Redeem</Link>
      }

      <motion.div whileTap={{ scale: 0.9 }} onClick={() => { toggleDetails(!showDetails); }} className={styles.detailsToggle}>
        <span>Additional Details</span>
        <span>{ showDetails ? '-' : '+'}</span>
      </motion.div>

      {
        showDetails &&
        <p className={styles.details}>{ decodeURIComponent(rewardCard.longDescription) }</p>
      }

      {
        (rewardCard.related && rewardCard.related.length !== 0) &&
        <div className={styles.rewards}>
          <strong>You may also like</strong>
          {
            rewardCard.related.map(x => {
              let rewardCard = config.rewards.find(z => z.id === x);
              let rewardObj = rewards.find(z => z.id === x);
              if(rewardCard && rewardObj) {
                if(x.banner) {
                  return <ProductBannerCard key={x} image={x.bannerImage} title={rewardCard.title} points={rewardObj.points} id={x} buttonText={rewardCard.bannerButtonText} buttonColour={rewardCard.bannerButtonColour} buttonTextColour={rewardCard.bannerButtonTextColour} textColour={rewardCard.bannerTextColour }/>
                }
                return <ProductCard key={x} image={rewardCard.image} title={rewardCard.title} points={rewardObj.points} id={x} />
              } else {
                return <div key={x}></div>
              }
            })
          }
          <Link to="/rewards" className={styles.button}>All rewards</Link>
        </div>
      }
    </motion.div>
  )
}

export default Reward;
